module.exports = {"StatusCode":200,"Payload":"[{\"key\": \"accountType\", \"value\": \"bundle\"}]"}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/applyAccountCode.json
// module id = qQNC
// module chunks = 0